export default __webpack_public_path__ + "static/media/Group -4@2x.af03d36d.png";